import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { ArrowRight } from 'lucide-react'
import { enterVariants } from '../../lib/motion'

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden border-t border-white/[0.06] bg-mesh-hero">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        transition={{ staggerChildren: 0.07 }}
        className="mx-auto max-w-3xl px-4 py-28 text-center md:py-32"
      >
        <motion.h2
          variants={enterVariants}
          className="text-balance text-[1.875rem] font-semibold tracking-[-0.025em] text-white md:text-h2"
        >
          Try it on{' '}
          <span className="relative inline-block">
            <span
              aria-hidden
              className="absolute -inset-x-4 inset-y-1 -z-10 rounded-full bg-primary-400/20 blur-3xl"
            />
            your last set of notes
          </span>
        </motion.h2>

        <motion.p
          variants={enterVariants}
          className="mx-auto mt-4 max-w-md text-body text-white/50"
        >
          Connect Trello, paste a transcript, see what comes out.
        </motion.p>

        <motion.div variants={enterVariants} className="mt-10">
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 rounded-lg bg-white px-5 py-3 text-body font-medium text-surface-base transition-[transform,opacity] duration-150 ease-out hover:opacity-90 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base"
          >
            Start free
            <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>
      </motion.div>
    </section>
  )
}
